import PlusIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import {
  AppBar,
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Collapse,
  Dialog,
  Divider,
  IconButton,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography,
} from "@mui/material";
import { TransitionProps } from "@mui/material/transitions";
import React, { useEffect, useState } from "react";
import { fetchInventoryData } from "../../services/inventoryService";
import { useDebounce } from "../../Hooks/useDebounce";
import { addInventory } from "../../services/transferService";
import { useSelector } from "react-redux";
import { RootState } from "../../store";
import { brandColors } from "../../App";

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<unknown>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DcInventory: React.FC = () => {
  const [inventory, setInventory] = useState<any[]>([]); // Type it properly based on your data
  const [loading, setLoading] = useState<boolean>(true);
  const [productOptions, setProductOptioins] = useState<
    { value: string; label: string }[]
  >([]);
  const [selectedProduct, setSelectedProduct] = useState<{
    name: string;
    product_id: string;
    description: string;
    units: number;
  }>({ name: "", product_id: "", description: "", units: 0 });
  const [productList, setProductList] = useState<any[]>([]);
  const [selectedProductList, setSelectedProductList] = useState<any[]>([]);
  const [open, setOpen] = React.useState(false);
  // deboubce the search
  const [searchQuery, setSearchQuery] = useState<string>("");
  const debouncedSearchQuery = useDebounce(searchQuery, 500);
  const token = useSelector((state: RootState) => state.auth.token);
  const user = useSelector((state: RootState) => state.auth.user);
  const [expandedCategories, setExpandedCategories] = useState<string[]>([]);
  const [expandedSubCategories, setExpandedSubCategories] = useState<string[]>(
    []
  );
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  // Fetch inventory data when the component mounts
  const getInventoryData = async () => {
    try {
      const data = await fetchInventoryData(); // Fetch the inventory data from an API
      setInventory(restructureData(data));
      const tempData = restructureData(data);
    } catch (error) {
      console.error("Error fetching inventory:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getInventoryData();
  }, []);

  // Handle clicking on a row (maybe for more details or editing)
  const handleRowClick = (category: string) => {
    setExpandedCategories(
      (prev) =>
        prev.includes(category)
          ? prev.filter((c) => c !== category) // collapse
          : [...prev, category] // expand
    );
  };
  const handleProductSearch = async (product: string) => {
    try {
      const response = await fetch("/api/products/search", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ q: product || "", limit: 15 }),
      });
      const data = await response.json();
      if (data.length > 0) {
        setProductOptioins(
          data.map((item: any) => ({
            value: item.product_id,
            label: item.name,
          }))
        );
        setProductList(data);
      } else {
        setProductOptioins([]);
        setProductList([]);
      }
    } catch (error) {
      console.error("Error fetching inventory:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleAddProductToList = () => {
    if (
      selectedProduct.name !== "" ||
      selectedProduct.product_id !== "" ||
      selectedProduct.units !== 0
    ) {
      //check if the product is alredy in the list do not add
      const existingProduct = selectedProductList.find(
        (itm: any) => itm.product_id === selectedProduct.product_id
      );
      if (existingProduct) return alert("Product already in the list");
      const item = productList.find(
        (item: any) => item.product_id === selectedProduct.product_id
      );
      setSelectedProductList([
        ...selectedProductList,
        {
          ...selectedProduct,
          description: item.description,
          qty_packed: Number(item.packed),
          units: Number(selectedProduct.units),
          supplier: item.supplier,
        },
      ]);
      setSelectedProduct({
        name: "",
        product_id: "",
        description: "",
        units: 0,
      });
    } else {
      alert("Please select a product or enter valid quantity.");
    }
  };
  const restructureData = (data: any) => {
    const result: any = [];

    data.forEach((item: any) => {
      const { category, sub_category, ...productDetails } = item;

      // Find or create category group
      let categoryGroup = result.find((c: any) => c.category === category);
      if (!categoryGroup) {
        categoryGroup = { category, subcategories: [] };
        result.push(categoryGroup);
      }

      // Find or create subcategory group
      let subCategoryGroup = categoryGroup.subcategories.find(
        (s: any) => s.sub_category === sub_category
      );
      if (!subCategoryGroup) {
        subCategoryGroup = { sub_category, products: [] };
        categoryGroup.subcategories.push(subCategoryGroup);
      }

      // Push product to subcategory
      subCategoryGroup.products.push(productDetails);
    });

    return result;
  };
  const handleSave = async () => {
    // if the list is empty return with alert
    if (selectedProductList.length === 0)
      return alert("Please add item to the list");
    // save the selected product list
    try {
      const response = await fetch("/api/transfers/addInventoryTransfer", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ items: selectedProductList }),
      });
      if (response.status !== 200) {
        console.log("Error in handleSAve", response);
        return;
      }
      alert("Inventory added successfully");
      setSelectedProductList([]);
      getInventoryData();
      setOpen(false);
      handleClose();
    } catch (error) {
      console.log("Error adding inventory request");
    }
  };
  useEffect(() => {
    handleProductSearch(debouncedSearchQuery);
  }, [debouncedSearchQuery]);
  const handleSubCategoryClick = (subCategory: string) => {
    setExpandedSubCategories(
      (prev) =>
        prev.includes(subCategory)
          ? prev.filter((c) => c !== subCategory) // collapse
          : [...prev, subCategory] // expand
    );
  };
  return (
    <>
      <Box sx={{ padding: 1 }}>
        {loading ? (
          <CircularProgress sx={{ display: "block", margin: "0 auto" }} />
        ) : (
          <TableContainer component={Paper} sx={{ height: "80vh" }}>
            <Table
              stickyHeader
              size="small"
              sx={{
                // minWidth: 650,
                border: "1px solid #E3E6E1",
                borderRadius: "8px",
                overflow: "hidden",
              }}
            >
              {/* ================= TABLE HEADER (LEVEL 1) ================= */}
              <TableHead>
                <TableRow>
                  <TableCell
                    align="right"
                    sx={{
                      width: "50px",
                      backgroundColor: brandColors.header,
                      color: "#FFFFFF",
                      fontWeight: 600,
                      fontSize: "17px",
                    }}
                  >
                    No
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      backgroundColor: brandColors.header,
                      color: "#FFFFFF",
                      fontWeight: 600,
                      fontSize: "17px",
                      textAlign: "left",
                      pl:'20%',
                    }}
                  >
                    Category
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {inventory.map((item: any, index: number) => (
                  <React.Fragment key={item.category}>
                    {/* ================= CATEGORY ROW ================= */}
                    <TableRow
                      hover
                      onClick={() => handleRowClick(item.category)}
                      sx={{
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#EEF4EA" },
                      }}
                    >
                      <TableCell
                        align="right"
                        sx={{
                          fontWeight: 600,
                          fontSize: "15px",
                          color: "#1F1F1F",
                        }}
                      >
                        {index + 1}
                      </TableCell>
                      <TableCell
                        align="center"
                        sx={{
                          fontWeight: 600,
                          fontSize: "15px",
                          color: "#1F1F1F",
                          textAlign: "left",
                          pl:'20%',
                        }}
                      >
                        {item.category}
                      </TableCell>
                    </TableRow>

                    {/* ================= EXPANDED CATEGORY ================= */}
                    {expandedCategories.includes(item.category) && (
                      <TableRow sx={{ backgroundColor: "#f7fdf2ff" }}>
                        <TableCell colSpan={2}>
                          {item?.subcategories?.map((sub: any) => (
                            <Box key={sub.sub_category} sx={{ mb: 1 }}>
                              {/* ================= SUB-CATEGORY HEADER ================= */}
                              <Typography
                                onClick={() =>
                                  handleSubCategoryClick(sub.sub_category)
                                }
                                sx={{
                                  fontSize: "13px",
                                  fontWeight: 600,
                                  color: "#2F6B2F",
                                  cursor: "pointer",
                                  textAlign: "left",
                                  pl: '30%',
                                  py: 1,
                                  px: -1,
                                  borderBottom: "1px solid #D1D1D1",
                                  "&:hover": { backgroundColor: "#E3E6E1" },
                                }}
                              >
                                {sub.sub_category}
                              </Typography>

                              {/* ================= PRODUCT TABLE (LEVEL 3) ================= */}
                              {expandedSubCategories.includes(
                                sub.sub_category
                              ) && (
                                <Box
                                  sx={{
                                    mt: 1,
                                    border: "1px solid #E3E6E1",
                                    borderRadius: "5px",
                                    overflow: "hidden",
                                    backgroundColor: "#FFFFFF",
                                  }}
                                >
                                  <Table
                                    size="small"
                                    stickyHeader
                                    sx={{ border: "1px solid #91a883ff" }}
                                  >
                                    <TableHead>
                                      <TableRow
                                        sx={{
                                          backgroundColor: brandColors.header,
                                        }}
                                      >
                                        {[
                                          "Product",
                                          "Store",
                                          "Pack",
                                          "Quantity",
                                          "Total",
                                          ...(user?.role === "SuperAdmin"
                                            ? ["Cost"]
                                            : []),
                                        ].map((label) => (
                                          <TableCell
                                            key={label}
                                            align="center"
                                            sx={{
                                              backgroundColor:
                                                brandColors.header,
                                              color: "#FFFFFF",
                                              fontWeight: 600,
                                              fontSize: "14.5px",
                                            }}
                                          >
                                            {label}
                                          </TableCell>
                                        ))}
                                      </TableRow>
                                    </TableHead>

                                    <TableBody>
                                      {sub.products.map((prod: any) => (
                                        <TableRow key={prod.product_id} hover>
                                          <TableCell
                                            align="center"
                                            sx={{
                                              fontSize: "14px",
                                              fontWeight: 600,
                                            }}
                                          >
                                            {prod.product_name}
                                          </TableCell>

                                          <TableCell
                                            align="center"
                                            sx={{ fontSize: "14px" }}
                                          >
                                            {prod.store_name}
                                          </TableCell>

                                          <TableCell
                                            align="center"
                                            sx={{ fontSize: "14px" }}
                                          >
                                            {prod.packed} {prod.unit}
                                          </TableCell>

                                          <TableCell
                                            align="center"
                                            sx={{ fontSize: "14px" }}
                                          >
                                            {prod.qty_packed}
                                          </TableCell>

                                          <TableCell
                                            align="center"
                                            sx={{ fontSize: "14px" }}
                                          >
                                            {prod.qty_packed * prod.packed}
                                          </TableCell>

                                          {user?.role === "SuperAdmin" && (
                                            <TableCell
                                              align="center"
                                              sx={{ fontSize: "14px" }}
                                            >
                                              {prod.cost}
                                            </TableCell>
                                          )}
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Box>
                              )}
                            </Box>
                          ))}
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 1,
            dropshadow: 1,
            height: 45,
          }}
        >
          <Button
            variant="contained"
            size="medium"
            color="primary"
            onClick={handleClickOpen}
          >
            + Add Inventory
          </Button>
        </Box>
      </Box>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        sx={{ marginTop: 10 }}
        slots={{
          transition: Transition,
        }}
      >
        <AppBar sx={{ position: "relative" }} color="default">
          <Toolbar
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
              <Autocomplete
                disablePortal
                options={productOptions}
                sx={{ minWidth: 300, flexGrow: 1 }}
                value={
                  selectedProduct.name
                    ? {
                        value: selectedProduct.product_id,
                        label: selectedProduct.name,
                      }
                    : null
                }
                onChange={(e, value) =>
                  setSelectedProduct({
                    ...selectedProduct,
                    name: value?.label || "",
                    product_id: value?.value || "",
                  })
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Search products"
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                )}
              />
              <TextField
                id="outlined-basic"
                label="Quantity"
                variant="outlined"
                value={selectedProduct.units}
                type="number"
                onChange={(e) =>
                  setSelectedProduct({
                    ...selectedProduct,
                    units: Number(e.target.value),
                  })
                }
              />

              <Button
                autoFocus
                color="success"
                sx={{ borderRadius: 2, border: "2px solid green" }}
                onClick={handleAddProductToList}
              >
                <PlusIcon />
              </Button>
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', gap: 15}}>
            <Button
              autoFocus
              onClick={handleSave}
              sx={{
                borderRadius: 10,
                border: "2px solid green",
                backgroundColor: "green",
                color: "whitesmoke",
              }}
            >
              Save
            </Button>
              <Button
              autoFocus
              onClick={handleClose}
              color="error"
              variant="outlined"
              sx={{
                borderRadius: 10,
              }}
            >
              Cancel
            </Button>
            </div>
          </Toolbar>
        </AppBar>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: brandColors.header,
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                  align="left"
                >
                  Name
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: brandColors.header,
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                  align="center"
                >
                  Packed QTY
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: brandColors.header,
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                  align="center"
                >
                  Ordered Pack
                </TableCell>
                <TableCell
                  sx={{
                    backgroundColor: brandColors.header,
                    color: "white",
                    fontWeight: "bold",
                    fontSize: "16px",
                  }}
                  align="center"
                >
                  Ordered QTY
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedProductList.map((item) => (
                <TableRow
                  key={item.product_id}
                  sx={{ ":hover": { bgcolor: "#b8d0e6ff" } }}
                >
                  <TableCell component="th" scope="row">
                    {item.name}
                  </TableCell>
                  <TableCell align="center">{item.qty_packed}</TableCell>
                  <TableCell align="center">{item.units}</TableCell>
                  <TableCell align="center">
                    {item.units * item.qty_packed} Kg
                  </TableCell>
                </TableRow>
              ))}
              <TableRow sx={{ backgroundColor: brandColors.gray1 }}>
                <TableCell align="left" sx={{ fontWeight: "bold" }}>
                  Total
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {selectedProductList.length} Products
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {selectedProductList.reduce(
                    (total, item) => total + item.units,
                    0
                  )}
                </TableCell>
                <TableCell align="center" sx={{ fontWeight: "bold" }}>
                  {selectedProductList.reduce(
                    (total, item) => total + item.units * item.qty_packed,
                    0
                  )}{" "}
                  Kg
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Dialog>
    </>
  );
};

export default DcInventory;
